import { Grid, Paper, Typography, WithStyles } from "@material-ui/core";
import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./ProductCategory.styles";
import { ProductCard } from "./ProductCard";
import { LOGOS } from "./VenueConfig";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

export interface ProductCategoryProps extends WithStyles<typeof styles> {
    category: any;
    products: any;
    subcategoryActive?: string;
    isA7?: boolean;
    isSampleData?: boolean;
    onClick?: any;
}

const ProductCategoryPure: React.FunctionComponent<ProductCategoryProps> = ({
    classes,
    category,
    products,
    subcategoryActive,
    isA7,
    isSampleData,
    onClick
}) => {
    if (products == null || products.length === 0) {
        return null;
    }

    return <div key={category.id} className={classes.productSection}>
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Paper className={classes.sectionTitle} id={category.id}>
                    <Typography variant="h2">{category.name}</Typography>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1" className={classes.sectionDescription}>
                    <span dangerouslySetInnerHTML={{ __html: category?.description }} />
                </Typography>
            </Grid>
            {subcategoryActive !== ""
                ? <Grid item xs={12}>
                    <Paper className={classes.sectionTitle} id={subcategoryActive}>
                        <Grid container alignItems="center" direction="row">
                            <Grid item>
                                <ArrowBackIcon className={classes.clickableIcon} color="primary"
                                               onClick={() => onClick(category.id, "")} />
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant="h4">{category.subcategories.find(subcategory => subcategory.id === subcategoryActive)?.name}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                : null}

            <Grid container spacing={3}>
                {category.subcategories.length > 0 && subcategoryActive === "" ? category.subcategories.map(subcategory => {
                        const subcategoryProducts = products.filter(product => product.subcategory === subcategory.id);
                        const venues: any = [...new Set(subcategoryProducts.map(product => product.venue[0]))];
                        venues.length = Math.min(venues.length, 3);
                        return subcategoryProducts.length > 0 && <Grid key={subcategory.id} item xs={4}>
                            <ProductCard identifier={subcategory.id} title={subcategory.name}
                                         logos={venues.map(venue => venue in LOGOS
                                             ? ({path: LOGOS[venue], name: venue})
                                             : null)
                                             .filter(e => e)}
                                         isA7={isA7}
                                         isSampleData={isSampleData}
                                         onClick={() => onClick(category.id, subcategory.id)} />
                        </Grid>;
                    })
                    : products.map(product => {
                        return <Grid key={product.name} item xs={4}>
                            <ProductCard identifier={product.id} title={product.name}
                                         logos={product.venue?.map(venue => venue in LOGOS
                                             ? ({path: LOGOS[venue], name: venue})
                                             : null)
                                             .filter(e => e)}
                                         isA7={isA7}
                                         isSampleData={isSampleData}
                                         productOptions={product.order?.buyingOptions} prices={product.order} />
                        </Grid>;
                    })}
            </Grid>
        </Grid>
    </div>;
};

export const ProductCategory = withStyles(styles)(ProductCategoryPure);